if (!customElements.get('algolia-product-list')) {  
  function customSort(arr) {
    return arr.sort((a, b) => {
        if (typeof a === 'number' && typeof b === 'number') {
            return a - b; // Numerical sort
        } else if (typeof a === 'string' && typeof b === 'string') {
            return a.localeCompare(b); // Alphabetical sort
        } else if (typeof a === 'number') {
            return -1; // Numbers come before strings
        } else {
            return 1; // Strings come after numbers
        }
    });
  }

  customElements.define(
    'algolia-product-list',
    class AlgoliaProductList extends HTMLElement {
      constructor() {
        super();
        this.isInit = false;
        this.algoliaClient = false;
        this.currentIndex = 'shopify_products';
        this.productsPerPage = 64;
        this.page = 0;
        this.offset = 0;
        this.appliedFilters = '';
        this.query = '';
        this.queryID = '';
        this.colorFilterValues = false;
        this.categoryTag = this.dataset.categoryOverride || 'category';
        this.hiddenSizesPresent = false;
        this.patternFilterValues = false;
        this.excluded_cats = this.dataset.excludedCategories.split(',');
        this.limitedFilters = this.dataset.limitedFilters;
        this.limitedFilterFacets = [
          'price_range', 
          'options.size', 
          'named_tags.fabric-class', 
          'named_tags.color-family', 
          'option_names'
        ];
        this.filterValuesExcludedFromDisplay = [
          '10B',
          '10C',
          '10D',
          '10DD',
          '12D',
          '12DD',
          '14D',
          '14DD',
          '16DD',
          '4B',
          '6B',
          '6C',
          '6D',
          '6DD',
          '8B',
          '8C',
          '8D',
          '8DD',
          '18W',
          '22W'
        ];      
                
        this.facetPrefixesExcludedFromDisplay = [ // Partial or full strings
          'options.'
        ];
        this.facetsExcludedFromDisplay = [ // Full strings
          'named_tags.average-rating',
          `named_tags.${this.categoryTag}`,
          'tags',
          'collections',
          'collection_ids',
          'vendor',
          'price',
          'options.cup_size',
          'options.waist_size',
          'options.inseam_size',
          'options.band_size',
          'options.denomination',
          'options.denominations',
          'named_tags.category',
          'named_tags.pattern',
          'id',
          'named_tags.badge',
          'named_tags.brand', 
          'named_tags.size-type', 
          'named_tags.type', 
          'named_tags.style', 
          'named_tags.color-code',
          'inventory_available',
          'named_tags.size-chart',
          'named_tags.publication-list',
          'named_tags.rating-count',
          'named_tags.style-number',
          'named_tags.material-composition',
          'named_tags.color-description',
          'named_tags.fabric-type',
          'product_type',
          'named_tags.state',
          'named_tags.sale',
          'named_tags_names',
          "meta.custom.active_date",
          "meta.custom.demand",
          "meta.venus.inventory_type",
          "compare_at_price",
        ];
        
        // change filter names visually
        this.labelOverrides = [
          {
            original: 'fabric class',
            override: 'Prints'
          },
          {
            original: 'price range',
            override: 'Price'
          },
          {
            original: 'customer rating',
            override: 'Rating'
          },
          {
            original: 'sleeve length type',
            override: 'Sleeve Length'
          }
        ];
        
        // group sizes under main items to reduce number of displayed sizes
        // all get applied and removed as a group
        this.sizeGroupings = {
          'XS (0-2)': ['XXS', 'XXSP', 'XS', '0', '2', '3', 'XS/S', 'XSP', '3P', '0P', '2P'],
          'S (4-6)': ['S', 'SP', '3', '4', '5', '6', 'XS/S', 'S/M', '3P', '4P', '6P'],
          'M (8-10)': ['M', '8', '10', 'S/M', 'M/M', 'M/L', 'MP', '10P', '8P'],
          'L (12-14)': ['L', '12', '14', 'M/L', 'L/XL', 'LP', '12P'],
          'XL (16)': ['XL', '16', 'L/XL'],
          '1X (18-20)': ['1X', '18', '20', '1X/2X', 'XXL'],
          '2X (22-24)': ['2X', '22', '24', '1X/2X', '2X/3X'],
          '3X (26-28)': ['3X', '26', '28', '2X/3X'],
          'O/S': ['O/S', 'OS']
        };
        
        // handle converting hidden mapped variant sizes (from metafield)
        // to group into user-facing sizes
        
        /*
        REFERENCE
        *
        *
        * 
        Hidden size = variant metaifield mapped values
        *
        A = 32:B,34:A
        B = 32:C,34:B,36:A
        C = 32:D,34:C,36:B
        D = 32:DD,34:D,36:C
        DD = 32:DD,34:D,36:C
        DDD = 32:G,34:DDD,36:DD
        G = 34:G,36:DDD
        D2 = 38:B,40:A
        DD2 = 38:C,40:B
        DDD2 = 38:D,40:C
        G2 = 38:DD,40:D
        *
        */
      
        this.bandSizeGroupings = {
          32: ['A', 'B', 'C', 'D', 'DD', 'DDD'],
          34: ['A', 'B', 'C', 'D', 'DD', 'DDD', 'G'],
          36: ['B', 'C', 'D', 'D', 'DD', 'DDD', 'G'],
          38: ['D2', 'DD2', 'DDD2', 'G2'],
          40: ['D2', 'DD2', 'DDD2', 'G2']
        };
        this.cupSizeGroupings = {
          A: ['A', 'B', 'D2'],
          B: ['A', 'B', 'C', 'D2', 'DD2'],
          C: ['B', 'C', 'D', 'DD', 'DD2'],
          D: ['C', 'D', 'DD', 'G2'],
          DD: ['D', 'DD', 'DDD', 'G2'],
          DDD: ['DDD', 'G'],
          G: ['G', 'DDD']
        };
      }
      
      connectedCallback() {         
        if (window.algoliasearch) {
          this.init();
          return;
        }
        
        poll(() => {
          return window.algoliasearch;
        }, 10000, 150).then(() => {
          this.init();
        })
      }
      
      init() {
        if (this.isInit) return;     
        this.isInit = true;

        const searchParams = new URLSearchParams(window.location.search);
        const initialFilterString = searchParams.get('filters') ? decodeURI(searchParams.get('filters')) : false;
        const initialIndex = searchParams.get('index') ? decodeURI(searchParams.get('index')) : false;
        this.query = searchParams.get('q') ? decodeURI(searchParams.get('q')) : '';
        
        if (initialIndex) {
          this.querySelector('[data-action="algolia-sort"]').value = initialIndex;
          this.currentIndex = initialIndex;
        }
        
        this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale   
        this.collectionHandle = this.dataset.collectionHandle;
        this.customerId = this.dataset.customerId || false;
        this.appliedFilters = initialFilterString || this.buildFilterString();
        this.algoliaClient = window.algoliasearch(algoliaAppId, algoliaAPI);
        this.algoliaClient.initIndex(this.currentIndex);
        this.extraLimitedFacet = this.dataset.categoryOverride ? `named_tags.${this.dataset.categoryOverride}` : false
        this.extraLimitedFacet ? this.limitedFilterFacets.push(this.extraLimitedFacet) : this.limitedFilterFacets

        this.fetchFiltersOnly().then(async () => {
          this.fetchFilteredResults(false, true, true);
          if (Number(searchParams.get('page'))) {
            for (let i = 1; i <  Number(searchParams.get('page')); i++) {
              this.page ++;
              await this.fetchFilteredResults(false, true, false);
            }
            
            const lastObjId = localStorage.getItem('lastClickedObjectId');
            poll(() => {
              return this.querySelector(`[data-object-id="${lastObjId}"]`);
            }, 10000, 150).then(() => {
              this.querySelector(`[data-object-id="${lastObjId}"]`).scrollIntoView();
              localStorage.removeItem('lastClickedObjectId');
            })
          }
        });                    
        
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-object-id]')) {
            localStorage.setItem('lastClickedObjectId', e.target.closest('[data-object-id]').dataset.objectId);
          }
        });
        
        this.addDelegatedEventListeners();
      }
      
      addDelegatedEventListeners() {
        ['click', 'change'].forEach((eventType) => {
          this.addEventListener(eventType, debounce((e) => {
            const actionEl = e.target.closest('[data-action]');
            if (!actionEl) return;
            
            const {
              action,
              removeValue
            } = actionEl.dataset;
                        
            const searchParams = new URLSearchParams(window.location.search);

            switch(action) {
              case 'algolia-filter-change':
                this.appliedFilters = this.buildFilterString();
                this.fetchFilteredResults(false, true, true);
                searchParams.set('filters', this.appliedFilters);
                searchParams.set('page', 0);
                this.page = 0;
                
                history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
              break;
              
              case 'algolia-sort':
                const sortValue = actionEl.value;
                if (!sortValue || sortValue === this.currentIndex) return;
                searchParams.set('index', sortValue);
                this.currentIndex = sortValue;
                this.page = 0;
                searchParams.set('page', 0);
                this.fetchFilteredResults(false, true, true);

                history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
              break;
              
              case 'algolia-pagination-next':
                this.page ++;

                searchParams.set('page', (this.page + 1));
                history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);

                this.fetchFilteredResults(false, true, false);
              break;
              
              case 'remove-algolia-filter':
                searchParams.set('page', 0);

                if (this.querySelector(`[data-algolia-filter-group="named_tags.${this.categoryTag}"] input[value="${removeValue}"]`)) {
                  this.querySelector(`[data-algolia-filter-group="named_tags.${this.categoryTag}"] input[value=""]#no-category`)?.click();
                  return;
                }
                this.querySelector(`input[data-action="algolia-filter-change"][value="${removeValue}"]:checked`)?.click();
              break;
              case 'remove-all-algolia-filter':
                searchParams.set('page', 0);
                window.location = window.location.href.split('?')[0];
              break;
              
              case 'open-algolia-filter-drawer':
                this.querySelector('[data-filter-container]')?.classList.add('open');
                document.getElementById('MainContent').classList.replace('z-0', 'z-20');
                document.body.classList.add('overflow-hidden', 'h-screen');
              break;
              
              case 'close-algolia-filter-drawer':
                this.querySelector('[data-filter-container]')?.classList.remove('open');
                setTimeout(() => {
                  document.getElementById('MainContent').classList.replace('z-20', 'z-0');
                  document.body.classList.remove('overflow-hidden', 'h-screen');
                }, 501);
              break;
              
              case 'toggle-desktop-drawer':
                const drawer = this.querySelector('[data-desktop-drawer]');

                  drawer.classList.toggle('open');

                  const span = actionEl.querySelector('span');
                  const isOpen = drawer.classList.contains('open');
                  span.textContent = isOpen ? 'Hide Filters' : 'Show Filters';
              break;
              default: break;
            }
          }), 200);
        });
        
        window.addEventListener('resize', () => this.fetchFiltersOnly());
      }
      
      buildFilterString() {
        let filterString = this.collectionHandle && this.collectionHandle != 'all' ? `collections:${this.collectionHandle}` : '';
        const appliedFilters = [...this.querySelectorAll('[data-algolia-filter-group]')].map((filterGroup) => {
          const groupName = filterGroup.dataset.algoliaFilterGroup;
          const appliedValues = [...filterGroup.querySelectorAll('input[data-action="algolia-filter-change"]:checked')]
            .filter(filter => !!filter.value)
            .map(({ value, dataset: { additionalFilters, multiValue } }) => {
              if (multiValue === "true") {
                return (`${value.split(',').map(thisValue => `${groupName}:"${thisValue}"`).join(' OR ')}`)
              }
              if (additionalFilters) {
                return (`${groupName}:"${value}" OR ${additionalFilters}`)
              }
              
              return (`${groupName}:"${value}"`);
            }).join(' OR ')
          if (!appliedValues.length) return;
          
          return `(${appliedValues})`;
        }).filter((x) => !!x).join(' AND ').toString();
                
        if (appliedFilters.length) {
          filterString = filterString.concat(`${this.collectionHandle && this.collectionHandle != 'all' ? ' AND ' : ''}${appliedFilters} AND NOT tags:base-product AND NOT tags:hide-product AND inventory_available:true`);
        } else filterString = filterString.concat(`${this.collectionHandle && this.collectionHandle != 'all' ? ` AND` : ''} NOT tags:base-product AND NOT tags:hide-product  AND inventory_available:true`);
              
        return filterString;
      }
            
      formatLabel(label) {
       const newLabel = label.replace('named_tags.', '').replaceAll('_', ' ').replaceAll('-', ' ');
       const override = this.labelOverrides.find((x) => x.original === newLabel.trim().toLowerCase())?.override;
       
       if (override) {
        return override;
       }
       
       return newLabel;
      }
      
      async fetchFiltersOnly() {
        await this.algoliaClient.multipleQueries([{
          indexName: this.currentIndex,
          clickAnalytics: true,
          params: {
            facets: this.limitedFilters ? this.limitedFilterFacets : '*',
            filters: this.collectionHandle && this.collectionHandle != 'all' ? `collections:${this.collectionHandle} AND NOT tags:base-product AND NOT tags:hide-product  AND inventory_available:true` : 'NOT tags:base-product AND NOT tags:hide-product  AND inventory_available:true',
            hitsPerPage: this.productsPerPage,
            page: 0,
            query: this.query,
            ruleContexts: this.collectionHandle
          }
        }], 1, false).then((res) => {
          this.renderFilterRemovalButtons();
          this.renderFilters(res?.results?.[0]?.facets);
          this.renderCategories(res?.results?.[0]?.facets);
        });
      }
      
      async fetchFilteredResults(filters = true, products = true, replace = true) {
        await this.algoliaClient.multipleQueries([{
          indexName: this.currentIndex,
          clickAnalytics: true,
          params: {
            facets: '*',
            filters: this.appliedFilters,
            length: this.productsPerPage,
            offset: Math.max((this.productsPerPage * this.page) - this.offset, 0),
            query: this.query,
            ruleContexts: this.collectionHandle
          }
        }], 1, false).then((res) => {
          window.dispatchEvent(new CustomEvent('algolia:setData', { 
            detail: { 
              queryID: res.results[0]?.queryID,
              index: this.currentIndex
            } 
          }));
          
          if (res.results[0].userData && res.results[0].userData[0].redirect) {
            window.location.replace(res.results[0].userData[0].redirect);
            return
          }
          const totalResults = res.results[0].nbHits;
          const totalPages = Math.ceil(totalResults / this.productsPerPage);
          
          const noResults = document.querySelector('.no-search-results');
          if (noResults) {
            this.classList.toggle('hidden', totalResults === 0);
            noResults.classList.toggle('hidden', totalResults > 0);
          }

          this.offset = 0;

          this.queryID = res.results[0].queryID;
          this.renderFilterRemovalButtons();
          
          if (filters) {
            this.renderFilters(res?.results?.[0]?.facets);
          }
          if (products) {
            this.renderProducts(res?.results?.[0]?.hits, replace, res?.results?.[0]?.userData?.[0]?.banners);
          }
          
          if (totalPages <= (this.page + 1)) {
            this.classList.add('fully-loaded');
          } else {
            this.classList.remove('fully-loaded');
          }
          
          if (this.querySelector('[data-products-loaded]')) {
            if (this.classList.contains('fully-loaded')) {
              this.querySelector('[data-products-loaded]').innerText = totalResults;
            } else {
              this.querySelector('[data-products-loaded]').innerText = (this.page + 1) * this.productsPerPage;
            }
          } 

          if (document.querySelector('[data-total-products]')) {
            document.querySelectorAll('[data-total-products]').forEach(el => {
              el.innerText = totalResults;
            });
          }
          
          if (this.query) {
            document.querySelector('title').innerText = `Search: ${totalResults} results found for "${this.query}" – VENUS`;
            document.querySelector('[property="og:title"]').innerText = `Search: ${totalResults} results found for "${this.query}" – VENUS`;
          }
             
          const columns = window.matchMedia('(min-width: 1024px)').matches ? 4 : 2;
          window.dispatchEvent(new CustomEvent('productList:productsDisplay', { 
            detail: { 
              productsPerPageShown: (this.productsPerPage * (this.page + 1)),
              pageItemCount: (this.productsPerPage * this.page) + res.results[0]?.hits.length,
              columnCount: columns,
              rowCount: ((this.productsPerPage * this.page) + res.results[0]?.hits.length) / columns,
            }
          }));

        });
      }
      
      renderCheckbox = ({ label, value, id, swatch, formatAsPrice, additionalValueGroup, additionalValues, filterName, grouped_size_filters }) => {
        const searchParams = new URLSearchParams(window.location.search);
        let isChecked = filterName ?
          !!decodeURI(searchParams.get('filters'))?.toString()?.includes(`options.${filterName}:"${value}"`) :
          !!decodeURI(searchParams.get('filters'))?.toString()?.includes(`"${value}"`);

        if (grouped_size_filters) {
          const filters = decodeURI(searchParams.get('filters'));
          const sizeMatches = [...filters.matchAll(/options\.size:"(.*?)"/g)];
          const sizes = sizeMatches.map(match => match[1]);

          isChecked = value.every(size => sizes.includes(size));
        }

        
        return `
          <input 
            ${additionalValues && additionalValueGroup ? `
              data-additional-filters='${additionalValues.map((value) => `${additionalValueGroup}:${value}`).join(' OR ')}'
            ` : ''}
            data-multi-value="${value?.constructor == Array}"
            title="${label}" ${isChecked ? 'checked' : ''} 
            id="${id}" 
            type="checkbox" 
            value="${value}" 
            data-filter="${filterName}:${value}"
            data-action="algolia-filter-change"
          >
          <label for="${id}">
            ${swatch ? `
              <span 
                style="
                  background-color: ${label}; 
                  background-image: url('/cdn/shop/files/swatch-filter-${encodeURI(label.toLowerCase().replaceAll(' ', '-'))}_small.png');
                " 
                class="swatch rounded-full"
              ></span>
            ` : ''}
            ${formatAsPrice ? `$${label.replaceAll(':', ' - $')}` : label}
          </label>
        `;
      }
      
      renderColorAndPatterns() {
        const colors = ['RED', 'ORANGE', 'YELLOW', 'GREEN', 'BLUE', 'PURPLE', 'PINK', 'BROWN', 'NEUTRAL', 'WHITE', 'GREY', 'BLACK', 'METALLIC', 'MULTI']; //Color order
        if (!this.colorFilterValues && !this.patternFilterValues) return;
        return `
        ${this.colorFilterValues && this.patternFilterValues ? `
          <ul class="flex !flex-row gap-4 overflow-x-auto items-center justify-start w-full md:w-max max-w-full md:p-6 pb-4 peer">
            ${this.colorFilterValues ? `
              <li class="block relative w-full">
                <input 
                  class="absolute top-0 left-0 w-full h-full opacity-0 peer unstyled" 
                  title="Colors" 
                  id="colors-filter-category-toggle" 
                  type="radio" 
                  value="" 
                  name="colors-filter-category-toggle"
                  checked
                >
                <label 
                  class="max-md:button-sm w-full justify-center max-md:!uppercase peer-checked:w-full peer-hover:font-normal peer-hover:border-b-[1px] font-normal border-b-[1px] flex text-center items-center capitalize peer-hover:capitalize button-tertiary peer-hover:button-primary peer-checked:bg-primaryDark peer-checked:text-primaryLight transition duration-200 px-6 h-full min-h-16" 
                  for="colors-filter-category-toggle"
                >
                  Colors
                </label>
              </li>
            ` : ''}
            ${this.patternFilterValues ? `
            <li class="block relative w-full">
              <input 
                class="absolute top-0 left-0 w-full h-full opacity-0 peer unstyled" 
                title="Patterns" 
                id="patterns-filter-category-toggle" 
                type="radio" 
                value="" 
                name="colors-filter-category-toggle"
                ${!this.colorFilterValues ? `checked` : ''}
              >
              <label 
                class="max-md:button-sm w-full justify-center max-md:!uppercase peer-checked:w-full peer-hover:font-normal peer-hover:border-b-[1px] font-normal border-b-[1px] flex text-center items-center capitalize peer-hover:capitalize button-tertiary peer-hover:button-primary peer-checked:bg-primaryDark peer-checked:text-primaryLight transition duration-200 px-6 h-full min-h-16" 
                for="colors-filter-category-toggle"
              >
                Patterns
              </label>
            </li>
            ` : ''}
            </ul>` : '<div aria-hidden="true" class="pt-6 md:hidden"></div>'
          }
          ${this.colorFilterValues ? `
              <ul 
                data-algolia-filter-group="named_tags.color-family" 
                data-filter-name="named_tags.color-family" 
                class="filter-list filter-list-named-tags-color-family peer-has-[#patterns-filter-category-toggle:checked]:hidden"
              >
                ${this.colorFilterValues
                  .sort((a, b) => {
                    const indexA = colors.indexOf(a.toUpperCase());
                    const indexB = colors.indexOf(b.toUpperCase());
                    if (indexA === -1 && indexB === -1) return 0;
                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;
                    return indexA - indexB;
                  })
                  .map((value, i) => `
                    <li class="max-md:px-3 py-4 md:py-2 w-full filter-list-item ${value}">
                      ${this.renderCheckbox({
                        value, 
                        label: this.formatLabel(value).toLowerCase(),
                        id: `filter-value-${value}-${i}`,
                        swatch: true,
                        formatAsPrice: false
                      })}
                    </li>
                  `).join('')}
              </ul>
            ` : ''}
          ${this.patternFilterValues ? `
            <ul 
              data-algolia-filter-group="named_tags.pattern" 
              data-filter-name="named_tags.pattern" 
              class="filter-list filter-list-named-tags-color-family peer-has-[#colors-filter-category-toggle:checked]:hidden"
            >
              ${this.patternFilterValues.map((value, i) => `
                <li class="max-md:px-3 py-4 md:py-2 w-full filter-list-item ${value}">
                  ${this.renderCheckbox({
                    value, 
                    label: this.formatLabel(value),
                    id: `filter-value-${value}-${i}`,
                    swatch: true,
                    formatAsPrice: false
                  })}
                </li>
              `).join('')}
            </ul>
          ` : ``}
        `;
      }
      
      combineAverageRatings(values) {
        let combinedValues = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: []
        };
        const combinedValuesLookup = Object.keys(combinedValues);
        
        values.forEach((value) => {
          const lookup = combinedValuesLookup.find((x, i) => value >= x && (value < combinedValuesLookup[i + 1] || !combinedValuesLookup[i + 1]));
          combinedValues[lookup]?.push(value);
        });
        
        return combinedValues;
      }
      
      renderCombinedAverageRatings(combinedValues, id, filterName) {
        return `
          <ul data-algolia-filter-group="${id}" data-filter-name="${filterName}" class="filter-list filter-list-${filterName.replace('.', '-').replace('_','-')}">
            ${Object.keys(combinedValues).map((value, i) => {
              const values = combinedValues[i + 1];
              return (`
                <li 
                  class="
                    filter-list-item ${filterName.replace('_','-').replace('.', '-').replace(' ', '-')}-${value.replace(':', '-').replace('.', '-')}
                    max-md:px-3 
                    py-4
                    md:py-2
                    w-full 
                    filter-list-item 
                  "
                >
                  ${this.renderCheckbox({
                    value: values, 
                    label: `<div class='flex items-center gap-1'>
                      ${[...Array(Number(value)).keys()].map(() => `
                        <div class='w-4 h-4'>
                          <svg viewBox='0 0 16 16' height='100%' width='100%' focusable='false' role='img' fill='currentColor' xmlns='http://www.w3.org/2000/svg' class='StyledIconBase-ea9ulj-0 bWRyML'><title>StarFill icon</title><path d='M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z'></path></svg>
                        </div>
                      `).join('')}
                      <span>(${value})</span>
                    </div>`,
                    id: `filter-value-${value}-${i}`,
                    swatch: false,
                    formatAsPrice: false
                  })}
                </li>
            `)}).join('')}
          </ul>
        `;
      }
      
      combineGroupedSizes(values) {
        let combinedValues = {};
        const combinedValuesLookup = Object.keys(this.sizeGroupings);
    
        values.forEach((value) => {
            const matchingGroups = combinedValuesLookup.filter((x) => 
                this.sizeGroupings[x].some(y => y.toString().toLowerCase().trim() === value.toString().toLowerCase().trim())
            );
    
            if (matchingGroups.length === 0) matchingGroups.push('Other');
    
            matchingGroups.forEach((group) => {
                if (!combinedValues[group]) {
                    combinedValues[group] = [];
                }
                combinedValues[group].push(value);
            });
        });
    
        if (combinedValues['Other']) {
            const hiddenValues = [...new Set([...Object.values(this.bandSizeGroupings).flat(), ...Object.values(this.cupSizeGroupings).flat()])];
            this.hiddenSizesPresent = combinedValues['Other'].filter((value) => hiddenValues.includes(value));
            combinedValues['Other'] = combinedValues['Other'].filter((value) => !hiddenValues.includes(value));
        }
    
        return combinedValues;
    }
    
      
      renderGroupedSizes(filterName, combinedValues, id) {   
        return `
          <ul data-algolia-filter-group="${id}" data-filter-name="${filterName}" class="filter-list filter-list-size filter-list-${filterName.replace('.', '-').replace('_','-')}">
            ${Object.keys(combinedValues).map((value, i) => {
              const values = combinedValues[value];
              if (value === 'Other') {
                return values.map((value) => `
                  <li 
                    class="
                      filter-list-item ${filterName.replace('_','-').replace('.', '-').replace(' ', '-')}-${value.replace(':', '-').replace('.', '-')}
                      max-md:px-3 
                      py-4
                      md:py-2
                      w-full 
                      filter-list-item 
                    "
                  >
                    ${this.renderCheckbox({
                      value, 
                      label: `${value.replace('_','-')}`,
                      id: `filter-value-${value}-${i}`,
                      swatch: false,
                      formatAsPrice: false
                    })}
                </li>
                `).join('')
              }
              return (`
                <li 
                  class="
                    filter-list-item ${filterName.replace('_','-').replace('.', '-').replace(' ', '-')}-${value.replace(':', '-').replace('.', '-')}
                    max-md:px-3 
                    py-4
                    md:py-2
                    w-full
                    filter-list-item 
                  "
                >
                  ${this.renderCheckbox({
                    value: values, 
                    label: `${value.replace('_','-')}`,
                    id: `filter-value-${value}-${i}`,
                    swatch: false,
                    formatAsPrice: false,
                    grouped_size_filters: true,
                  })}
                </li>
            `)}).join('')}
          </ul>
        `;
      }
      
      renderGroupedBandSizes(subValues, id, filterName) {  
        if (!this.hiddenSizesPresent || this.limitedFilters && !this.limitedFilterFacets.find(x => x === `options.band_size`)) return;      
        let combinedValues = {};
        const combinedValuesLookup = Object.keys(this.bandSizeGroupings);
        
        this.hiddenSizesPresent?.forEach((value) => {
          const lookups = combinedValuesLookup.filter((x) => {
            return this.bandSizeGroupings[x].find(y => y.toString().toLowerCase().trim() === value.toString().toLowerCase().trim())
          }) ?? 'Other';
          
          lookups.forEach((lookup) => {
            if (!combinedValues[lookup]) {
              Object.assign(combinedValues, { [lookup]: [] })
            }
            
            combinedValues[lookup]?.push(value);
          });          
        });
                
        return `
          <ul data-algolia-filter-group="${id}" data-filter-name="${filterName}" class="filter-list filter-list-size filter-list-${filterName.replace('.', '-').replace('_','-')}">
            ${subValues.map((value, i) => {
              const additionalValues = combinedValues[value];
              return (`
                <li 
                  class="
                    filter-list-item ${filterName.replace('_','-').replace('.', '-').replace(' ', '-')}-${value.replace(':', '-').replace('.', '-')}
                    max-md:px-3 
                    py-4 
                    filter-list-item 
                  "
                >
                  ${this.renderCheckbox({
                    additionalValueGroup: `options.size`,
                    additionalValues,
                    value: value, 
                    label: this.formatLabel(value),
                    id: `filter-value-${value}-${i}`,
                    swatch: false,
                    formatAsPrice: false
                  })}
                </li>
            `)}).join('')}
          </ul>
        `;
      }
      
      renderGroupedCupSizes(subValues, id, filterName) {
        if (!this.hiddenSizesPresent || this.limitedFilters && !this.limitedFilterFacets.find(x => x === `options.cup_size`)) return;      
        let combinedValues = {};
        const combinedValuesLookup = Object.keys(this.cupSizeGroupings);
        
        this.hiddenSizesPresent?.forEach((value) => {
          const lookups = combinedValuesLookup.filter((x) => {
            return this.cupSizeGroupings[x].find(y => y.toString().toLowerCase().trim() === value.toString().toLowerCase().trim())
          }) ?? 'Other';
          
          lookups.forEach((lookup) => {
            if (!combinedValues[lookup]) {
              Object.assign(combinedValues, { [lookup]: [] })
            }
            
            combinedValues[lookup]?.push(value);
          });          
        });
                
        return `
          <ul data-algolia-filter-group="${id}" data-filter-name="${filterName}" class="filter-list filter-list-size filter-list-${filterName.replace('.', '-').replace('_','-')}">
            ${subValues.map((value, i) => {
              const additionalValues = combinedValues[value];
              return (`
                <li 
                  class="
                    filter-list-item ${filterName.replace('_','-').replace('.', '-').replace(' ', '-')}-${value.replace(':', '-').replace('.', '-')}
                    max-md:px-3 
                    py-4
                    md:py-2
                    w-full
                    filter-list-item 
                  "
                >
                  ${this.renderCheckbox({
                    additionalValueGroup: `options.size`,
                    additionalValues,
                    value: value, 
                    label: this.formatLabel(value),
                    id: `filter-value-${value}-${i}`,
                    swatch: false,
                    formatAsPrice: false
                  })}
                </li>
            `)}).join('')}
          </ul>
        `;
      }
      
      renderFilterList(filterName, subValuesUnsorted, id) {
        let subValues = customSort(subValuesUnsorted
          .filter((value) => !this.filterValuesExcludedFromDisplay.find((x) => x === value)));
        let label;
        if (filterName.includes('color-family')) {
          label = 'Color';
        } else if (filterName == `named_tags.type`){
          label = 'Category';
        } else {
          label = this.formatLabel(filterName);
        }
        
        const renderList = () => {
          if (label === 'Color') {
            return this.renderColorAndPatterns();
          }
          
          if (filterName === `named_tags.average-rating`) {
            return this.renderCombinedAverageRatings(this.combineAverageRatings(subValues), id, filterName)
          }
          
          if (filterName === `band`) {
            return this.renderGroupedBandSizes(subValues, id, filterName);
          }
          
          if (filterName === `cup`) {
            return this.renderGroupedCupSizes(subValues, id, filterName);
          }
          
          if (filterName === `size`) {
            return this.renderGroupedSizes(filterName, this.combineGroupedSizes(subValues), id)
          }
                    
          if (filterName === 'waist') {
            subValues = customSort([...subValues.map(x => Number(x))]).map(y => y.toString());
          }
          
          if (filterName === 'price_range') {
            function customKeySort(arr) {
              return arr.slice().sort((a, b) => {
                  const keyA = parseInt(a.split(':')[0], 10);
                  const keyB = parseInt(b.split(':')[0], 10);
                  return keyA - keyB;
              });
            }
            
            subValues = customKeySort(subValues);
          }
          
          return `
            <ul 
              data-algolia-filter-group="${id}" 
              data-filter-name="${filterName}" 
              class="filter-list ${filterName.includes('band') || filterName.includes('cup') || filterName.includes('waist') ? 'filter-list-size' : ''} filter-list-${filterName.replace('.', '-').replace('_','-')}"
            >
              ${subValues.map((value, i) => `
                <li class="max-md:px-3 py-4 md:py-2 w-full filter-list-item ${filterName.replace('_','-').replace('.', '-').replace(' ', '-')}-${value.replace(':', '-').replace('.', '-')}">
                  ${this.renderCheckbox({
                    value, 
                    label: this.formatLabel(value),
                    id: `filter-value-${value}-${i}`,
                    swatch: filterName.includes('color'),
                    formatAsPrice: filterName.toLowerCase()?.includes('price'),
                    filterName: filterName
                  })}
                </li>
              `).join('')}
            </ul>
          `;
        }
                      
        return window.renderAccordionItem({ 
          isOpenByDefault: !!this.querySelector(`[data-accordion-id="${id}"].active`) || filterName == 'gender' || filterName == 'size' && window.outerWidth > 768,
          label: label,
          icon: 'plus',
          content: renderList(),
          id,
          extraClass: `md:!border-t md:border-silver [&_button>span]:md:w-3 [&_button>span]:md:h-3 mobileFilter filter-list-${id.replace('_','-').replace('.', '-').replace(' ', '-')}`
        })
        
      }
      
      renderFilterGroupFromParentObj({ key, filters, filterValues, filterCounts }) {
        return filterValues.map((optionFilterName) => {
          const filter = `${key}.${optionFilterName}`;
          
          if (this.facetsExcludedFromDisplay.includes(filter)) return;
          if (!filters[filter]) return;
          
          const subFilterValues = Object.keys(filters[filter]);
          if (!subFilterValues) return;
          
          return this.renderFilterList(optionFilterName, subFilterValues, `${key}.${optionFilterName}`, filterCounts);
        }).join('');
      }
      
      renderFilterRemovalButtons() {
        const filterRemovalButtonsWraps = this.querySelectorAll('[data-remove-filters]');
        if (!filterRemovalButtonsWraps.length) return;
      
        const appliedValues = [...this.querySelectorAll('input[data-action="algolia-filter-change"]:not(#no-category):checked')];
      
        filterRemovalButtonsWraps.forEach((wrap) => {
          wrap.innerHTML = '';
      
          if (!appliedValues.length) return;
      
          wrap.insertAdjacentHTML('beforeend', `
            <button title="Remove all filter value" data-action="remove-all-algolia-filter" class="button-link text-sm text-secondaryDark" data-remove-value="">
              Clear All
            </button>
          `);
      
          let chipContainer = wrap.querySelector('[data-remove-filter-chips]');
          if (!chipContainer) {
            chipContainer = document.createElement('div');
            chipContainer.setAttribute('data-remove-filter-chips', '');
            wrap.appendChild(chipContainer);
          } else {
            chipContainer.innerHTML = '';
          }
      
          appliedValues.forEach((checkedInputEl) => {
            const categoryName = checkedInputEl.closest('[data-filter-name]')?.dataset.filterName || 'Unknown';
            chipContainer.insertAdjacentHTML('beforeend', `
              <button 
                ${checkedInputEl.value} filter value" 
                data-action="remove-algolia-filter" 
                class="remove-filter-button" 
                data-remove-value="${checkedInputEl.value}"
              >
                <span class="sr-only">Remove ${categoryName.replaceAll('_', ' ').replaceAll('-', ' ')} ${checkedInputEl.value} filter value</span>
                <span>${checkedInputEl.dataset.multiValue === 'true' ? checkedInputEl.title : checkedInputEl.value}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" aria-hidden="true">
                  <path d="M12.6668 4.47101L11.7268 3.53101L8.00016 7.25767L4.2735 3.53101L3.3335 4.47101L7.06016 8.19767L3.3335 11.9243L4.2735 12.8643L8.00016 9.13767L11.7268 12.8643L12.6668 11.9243L8.94016 8.19767L12.6668 4.47101Z" fill="#1C1C1C"/>
                </svg>
              </button>
            `);
          });
        });
      
      
        document.querySelectorAll('[data-total-filters]')?.forEach(el => el.innerText = appliedValues.length ? `(${appliedValues.length})` : ``);
      }
      
      renderCategories(filters) {
        const categories = filters?.[`named_tags.${this.categoryTag}`];
        const categoryWrap = this.querySelector('[data-category-filters]');
        if (!categories || !categoryWrap) return;
        const searchParams = new URLSearchParams(window.location.search);
          
        const existingValue = categoryWrap.querySelector('input:checked:not(#no-category)')?.value
        categoryWrap.innerHTML = `
          <ul 
            data-algolia-filter-group="named_tags.${this.categoryTag}" 
            data-filter-name="named_tags.${this.categoryTag}" 
            class="flex overflow-x-auto items-center justify-start w-max max-w-full"
          >
            <li class="block relative">
              <input 
                class="absolute top-0 left-0 w-full h-full opacity-0 peer unstyled" 
                title="All" 
                id="no-category" 
                type="radio" 
                name="named_tags.${this.categoryTag}"
                value="" 
                data-action="algolia-filter-change"
                data-filter=""
                ${!existingValue ? 'checked' : ''}
              >
              <label 
                class="flex text-center items-center capitalize border-b-[1px] peer-hover:border-b-[1px] button-tertiary peer-hover:button-primary peer-hover:capitalize peer-checked:bg-primaryDark peer-checked:text-primaryLight transition duration-200 px-3 max-md:text-sm md:px-20 h-full min-h-9  md:min-h-16 min-w-16 md:min-w-32 justify-center text-secondaryDark" 
                for="no-category"
              >
                All
              </label>
            </li>
            ${Object.keys(categories).filter(cat => !this.excluded_cats
              .some(x => x.toLowerCase().trim() === cat.toLowerCase().trim()))
              .map((value, i) => {
              const isChecked = !!decodeURI(searchParams.get('filters'))?.toString()?.includes(`"${value}"`);
              const label = this.formatLabel(value);
              const id = `filter-value-${value}-${i}`;
              
              return `
                <li class="block relative">
                  <input 
                    class="absolute top-0 left-0 w-full h-full opacity-0 peer unstyled" 
                    title="${label}" 
                    ${isChecked ? 'checked' : ''} 
                    id="${id}" 
                    type="radio" 
                    name="named_tags.${this.categoryTag}"
                    value="${value}" 
                    data-action="algolia-filter-change"
                  >
                  <label 
                    class="flex text-center items-center capitalize border-b-[1px] peer-hover:border-b-[1px] button-tertiary peer-hover:button-primary peer-hover:capitalize peer-checked:bg-primaryDark peer-checked:text-primaryLight transition duration-200 px-3 max-md:text-sm md:px-20 h-full min-h-9  md:min-h-16 min-w-16 md:min-w-32 justify-center text-secondaryDark" 
                    for="${id}"
                  >
                    ${label}
                  </label>
                </li>
              `
            }).join('')}
          </ul>
        `;
      }
 
      renderFilters(filtersInput) {
        let filters = filtersInput;
        if (!filters) return;
        
        window.dispatchEvent(new CustomEvent('algolia:filtersViewed', { 
          detail: { 
            filters
          } 
        }));

        if (filters[`options.size`]) {
          this.combineGroupedSizes(Object.keys(filters[`options.size`]));
          
          if ((!filters[`options.band`] || !filters[`options.cup`]) && this.hiddenSizesPresent) {
            let bandCombinedValues = {};
            let cupCombinedValues = {};
            const bandCombinedValuesLookup = Object.keys(this.bandSizeGroupings);
            const cupCombinedValuesLookup = Object.keys(this.cupSizeGroupings);

            this.hiddenSizesPresent?.forEach((value) => {
              const lookups = bandCombinedValuesLookup.filter((x) => {
                return this.bandSizeGroupings[x].find(y => y.toString().toLowerCase().trim() === value.toString().toLowerCase().trim())
              }) ?? 'Other';
              
              lookups.forEach((lookup) => {
                if (!bandCombinedValues[lookup]) {
                  Object.assign(bandCombinedValues, { [lookup]: [] })
                }
                
                bandCombinedValues[lookup]?.push(value);
              });          
              
              this.hiddenSizesPresent?.forEach((value) => {
                const lookups = cupCombinedValuesLookup.filter((x) => {
                  return this.cupSizeGroupings[x].find(y => y.toString().toLowerCase().trim() === value.toString().toLowerCase().trim())
                }) ?? 'Other';
                
                lookups.forEach((lookup) => {
                  if (!cupCombinedValues[lookup]) {
                    Object.assign(cupCombinedValues, { [lookup]: [] })
                  }
                  
                  cupCombinedValues[lookup]?.push(value);
                });          
              });
            })
            
            if (JSON.stringify(cupCombinedValues) !== '{}' && filters['option_names']) {
              filters['options.cup'] = {};
              Object.assign(filters['option_names'], { ['cup']: 1 })

              Object.keys(cupCombinedValues).forEach((x) => {
                Object.assign(filters['options.cup'], { [x]: 1 })
              });
            }
            if (JSON.stringify(bandCombinedValues) !== '{}' && filters['option_names']) {
              filters['options.band'] = {};
              Object.assign(filters['option_names'], { ['band']: 1 })

              Object.keys(bandCombinedValues).forEach((x) => {
                Object.assign(filters['options.band'], { [x]: 1 })
              });
            }
          }
        }
        
        const filtersWraps = this.querySelectorAll('[data-filters-wrap]');  
     
        
        // renderAccordionItem() from accordion.js
        filtersWraps.forEach((filterWrap) => {
          filterWrap.innerHTML = `
            <content-accordion> 
              <ul class="flex md:flex-wrap md:gap-x-8">
                ${Object.keys(filters).map((filter) => {
                  if (filter === `named_tags.print`) {
                    this.patternFilterValues = Object.keys(filters[filter]);
                  }
                  if (filter === `named_tags.color-family`) {
                    this.colorFilterValues = Object.keys(filters[filter]);
                  }
                  if (this.facetsExcludedFromDisplay.some(string => string === filter) || this.facetPrefixesExcludedFromDisplay.some((prefix => filter.indexOf(prefix) >= 0))) {
                    return ``;
                  }
                                    
                  const filterValues = Object.keys(filters[filter]);
                  if (filter.includes('option_names') || filter.includes('named_tags_names')) {
                    let key = filter.replace('_names', '');
                    if (key.slice(-1) !== 's') {
                      key = key.concat('s');
                    }
                                        
                    return this.renderFilterGroupFromParentObj({ 
                      key, 
                      filters: filters, 
                      filterValues: filterValues,
                      filterCounts: Object.values(filters[filter])
                    });
                  }
                  
                  return this.renderFilterList(filter, filterValues, filter, Object.values(filters[filter]));
                }).join('')} 
              </ul>
            </content-accordion> 
          `;
        });
      }

      renderBanner(banner) {
        const productsWrap = this.querySelector('[data-products-wrap]');
        const bannerURL = banner.url ? banner.url : false;
        const bannerImageURL = banner.image_url ? banner.image_url : '';
        const bannerVideoURl = banner.video_url ? banner.video_url : '';
        const bannerTitle = banner.title ? banner.title : '';
        const bannerText = banner.text ? banner.text : '';
        const bannerBtnLabel = banner.btn_label ? banner.btn_label : '';
        const bannerWidth = banner.width === 2 ? 2 : 1;
        const bannerTextWrapper = `
        <div class="absolute bottom-6 transform -translate-x-1/2 left-1/2 z-10 flex flex-col gap-2 bg-primaryLight text-primaryDark text-center w-[87%] p-2 md:p-6 font-heading">
          ${bannerTitle ? `<span class="leading-none text-2xl uppercase md:text-[35px]">${bannerTitle}</span>`: ``}
          ${bannerText ? `<span class="md:leading-none">${bannerText}</span>` : ``}
          ${bannerBtnLabel ? `<span class="text-sm font-medium uppercase md:leading-none border-b-2 border-primaryDark w-fit mx-auto p-[10px]">${bannerBtnLabel}</span>` : ``}
        </div>`;
        let bannerMedia;
        
        if (bannerImageURL) {
          bannerMedia = `<img src=${bannerImageURL} loading="lazy" class="w-full object-cover object-center ${bannerWidth == 2 ? 'aspect-[3/2]' : ''}">`;
        } else if (bannerVideoURl) {
          bannerMedia = `
            <video playsinline="playsinline" autoplay="autoplay" background="true" loop="loop" muted="muted" loading="lazy" class="w-full object-cover object-center ${bannerWidth == 2 ? 'aspect-[3/2]' : ''}">
              <source src="${bannerVideoURl}" type="video/mp4"/>
            </video>
          `;
        }

        productsWrap.insertAdjacentHTML(
          'beforeend',
          `<div class="relative w-full h-full flex ${bannerWidth == 2 ? 'col-span-2' : ''}">
            ${bannerURL ? `<a class="w-full h-full flex" href="${bannerURL}">` : ``}
              ${bannerMedia ? bannerMedia : ``}
              ${bannerImageURL ? `${bannerTitle || bannerText || bannerBtnLabel ? bannerTextWrapper : ''}` : ``}
            ${bannerURL ? `</a>` : ``}
          </div>`
        )
      }
      
      renderProducts(products, replace = true, banners = false) {
        window.dispatchEvent(new CustomEvent('algolia:productsViewed', { 
          detail: { 
            products
          } 
        }));
        const productsWrap = this.querySelector('[data-products-wrap]');
        if (!productsWrap) return;
        
        if (!products.length) {
          productsWrap.innerHTML = `
            <div class="no-results">
              <h3>No products match your query. Adjust your filters and try again.</h3>
            </div>
          `;
          return;
        };
        
        if (replace) productsWrap.innerHTML = '';
        
        const loader = document.querySelector(`template[data-loader="product-tile"]`)?.cloneNode(true);

        products.forEach((product, index) => {
          
          if (banners) {
            const indexBanner = banners.filter((banner) => banner.position - 1 == index).length ? banners.filter((banner) => banner.position - 1 == index)[0] : false;
            if(indexBanner) {
              this.renderBanner(indexBanner);
              this.offset += 1;

            }
          }

          if ((index) >= (this.productsPerPage - this.offset)) {
            return;
          }
          
          productsWrap.insertAdjacentHTML( // intersection-loader from intersection-loader.js
            'beforeend',
            `<intersection-loader 
              data-object-id="${product.objectID}"
              data-position="${product.position}"
              data-url="${this.locale ? `/${this.locale}` : `` }${this.collectionHandle ? `/collections/${this.collectionHandle}`: ''}/products/${product.handle}"
              data-section-id="product-tile"
              data-extra="position:${product.position},object-id:${product.objectID}"
            >${loader.innerHTML}</intersection-loader>`
          )
        });
      }
    }
  )
}